import { ResourceDescriptor } from "./common";

const user_alias: ResourceDescriptor = {
    url: "user_aliases",
    orders: {
        create: ["name"],
    },
    identifiers: ["name"],
    expand: {},
};

export default user_alias;
